import React from 'react'
import {Link} from 'react-router-dom'
import ReactCardFlip from 'react-card-flip'
import { IntroCircle } from '../../components/IntroCircle';
import {IntroCircleImg} from '../../components/IntroCircleImg'

class Home extends React.Component {
  constructor() {
    super();
    this.state = {
      isFlipped: false
    };
    this.handleClick = this.handleClick.bind(this);
  }
 
  handleClick(e) {
    e.preventDefault();
    this.setState(prevState => ({ isFlipped: !prevState.isFlipped }));
  }

  render() {
    return(
      <div className="home-container">
        <div className="social-link-container">
          <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/derek-williams-658580aa/" className="social-links">
            <i style={{fontSize:60}} className="fab fa-linkedin"></i>
          </a>
          <a target="_blank" rel="noopener noreferrer" href="https://github.com/dwilli77" className="social-links">
            <i style={{fontSize:60, marginLeft:15}} className="fab fa-github"></i>
          </a>
        </div>
        <div className="home-contact-info">
          <div>
            <Link to="/contact">
              <i className="material-icons prefix" style={{fontSize:30, color:'#fb8c00'}}>email</i>
              <h3 id="email-link" style={{display: 'inline-block'}}>&nbsp;dwilli77@gmail.com</h3>
            </Link>
          </div>
          <div>
            <i className="material-icons prefix" style={{fontSize:30, color:'#fb8c00'}}>phone</i>
            <h3 style={{display: 'inline-block', marginTop:0}}>&nbsp;865-221-9465</h3>
          </div>
        </div>
        <ReactCardFlip isFlipped={this.state.isFlipped}>
          <IntroCircle key="front" onClick={this.handleClick} />
          <IntroCircleImg key="back" onClick={this.handleClick} />
        </ReactCardFlip>
      </div>
    )
  }
}

export default Home;